import { useCallback } from 'react';

import { CANVAS_OBJECT_TYPE_PREFIX, SELECTION_CIRCLES } from '../constants';
import { CircleAction } from '../enums';

import { drawingTool } from '~/core/engine/DrawingTool';
import { useAppDispatch, useAppSelector } from '~/redux/hooks';
import {
  selectFabricCanvas,
  updateSelectionCircles,
} from '~/redux/slices/fabric';

export const useClearSelectionCircles = () => {
  const canvas = useAppSelector(selectFabricCanvas);
  const dispatch = useAppDispatch();

  const clearSelectionCircles = useCallback(() => {
    const selectionCircles = {
      selection: SELECTION_CIRCLES.FOR_NONE,
      action: CircleAction.NONE,
    };

    dispatch(updateSelectionCircles(selectionCircles));
    drawingTool.removeObjectByName(
      canvas,
      CANVAS_OBJECT_TYPE_PREFIX.SELECTION_CIRCLE
    );
  }, [canvas, dispatch]);

  return { clearSelectionCircles };
};
